import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Header.css";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../../BASE_URL";
import Offcanvas from 'react-bootstrap/Offcanvas';
import Modal from 'react-bootstrap/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRightFromBracket } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';

import { useAuthContext } from "../../context/AuthContext";

const Header = () => {
  const { setAuthUser } = useAuthContext();
  const navigate = useNavigate();

  const location = useLocation();

  const isVendorIncluded = location.pathname.includes("vendor");
  const [vendor, setVendor] = useState(isVendorIncluded);

  useEffect(() => {
    setVendor(location.pathname.includes("vendor"));
  }, [location]);

  const [name, setName] = useState("");
  const naviGATE = useNavigate();
  const token = localStorage.getItem("saptvidhiUserToken");

  const getUset = async () => {
    const res = await fetch(`${BASE_URL}/api/profile/userdetails`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    });
    const data = await res.json();

    const fullName = data?.data?.UserDetails?.user_name;
    const names = fullName?.split(" ");

    // Check if there are at least two names
    if (names?.length >= 2) {
      const firstName = names[0];
      const lastNameInitial = names[1].charAt(0);

      const abbreviatedName = `${firstName} ${lastNameInitial}`;
      setName(abbreviatedName)
    } else {
      setName(data?.data?.UserDetails?.user_name);
    }


  };

  useEffect(() => {
    if (token) {
      getUset();
    }
  }, [token]);

  const checkPersonalDetails = async () => {
    try {
      const res = await fetch(`${BASE_URL}/api/profile/userdetails`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      });
      const data = await res.json();
      
      // Check if essential personal details exist
      if (!data?.data?.UserDetails?.user_name || 
          !data?.data?.UserDetails?.dob || 
          !data?.data?.UserDetails?.gender) {
        toast.error("Please complete your personal details first", {
          position: toast.POSITION.TOP_CENTER,
        });
        navigate("/personal-deatils");
        return false;
      }
      return true;
    } catch (error) {
      console.error("Error checking personal details:", error);
      return false;
    }
  };

  const goToProfile = async () => {
    if (await checkPersonalDetails()) {
      navigate("/userprofile");
      setOpenDropDown(false);
    }
  };

  const goToMessages = async () => {
    if (await checkPersonalDetails()) {
      navigate("/messages");
      setOpenDropDown(false);
    }
  };

  const goToBlockList = () => {
    navigate("/blocklist")
    setOpenDropDown(false)
  }

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const navigate1 = useNavigate();

  const handleNav = async () => {
    if (token && token.length > 0) {
      navigate1("/profile");
      await getUset();
    } else {
      navigate1("/");
    }
  };

  const [show1, setShow1] = useState(false);

  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => {
    setShow1(true)
    setOpenDropDown(false)
  }


  const handleLogout = () => {
    handleClose();
    handleShow1();
  }

  const handleLog = () => {
    localStorage.clear("userToken");
    localStorage.clear("memberType");
    localStorage.clear("myprofilePhoto");
    setAuthUser(null)
    handleClose1();
    navigate("/login");
  }

  const handleNo = () => {
    handleClose1();
  }

  const goToChangePassword = () => {
    navigate("/change-password")
    setOpenDropDown(false)
  }
  const goToDeleteProfile = () => {
    navigate("/delete-profile")
    setOpenDropDown(false)
  }

  const handleLogin = () => {
    handleClose();
    navigate("/login")
  }

  const [openDropDown, setOpenDropDown] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setOpenDropDown((prev) => !prev);
  };

  const handleClickOutside = (event) => {
    // Check if the click was outside the dropdown and toggle button
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setOpenDropDown(false);
    }
  };

  useEffect(() => {
    if (openDropDown) {
      // Add the event listener only when the dropdown is open
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      // Remove the event listener if the dropdown is closed
      document.removeEventListener('mousedown', handleClickOutside);
    }

    // Cleanup listener on component unmount
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [openDropDown]);

  // Add these functions with your other navigation functions
  const [showAccountPrivacy, setShowAccountPrivacy] = useState(false);

  const toggleAccountPrivacy = () => {
    setShowAccountPrivacy(!showAccountPrivacy);
  };

  return (
    <div className="d-flex justify-content-center">
      <div className="header">
        <div className="h2__link ">
          <div>
            {vendor ? (
              <img src="/SaptaVidhi T.png" className="img_header_logo header-logo-photo" onClick={() => naviGATE("/vendor-homepage")} alt="" />
            ) : (
              <img src="/SaptaVidhi T.png" className="img_header_logo header-logo-photo" onClick={handleNav} alt="" />
            )}
          </div>
        </div>
        <Modal
          show={show1}
          onHide={handleClose1}
          backdrop="static"
          keyboard={false}
          centered
        >
          <Modal.Body className="text-center">
            <div className="modal-icon">
              <FontAwesomeIcon icon={faRightFromBracket} />
            </div>
            <p className="modal-title">Are you sure want to log out?</p>
            <div className="modal-buttons">
              <button className="logout-yes-no-1" onClick={handleNo}>
                No
              </button>
              <button onClick={handleLog} className="logout-yes-no-2">Yes</button>
            </div>
          </Modal.Body>
        </Modal>
        <div className="header__links w-100">
          <Link to={token ? "/profile" : "/"}>Home</Link>
          {token ? (
            <Link to="/requests">Requests</Link>
          ) : (
            ""
          )}
          <Link to={token ? '/SelectPlan' : '/SelectPlan'}>{token ? 'Our Plans' : 'Our Plans'}</Link>
          <Link to={token ? '/ContactUs' : '/ContactUs'}>{token ? 'Contact Us' : 'Contact Us'}</Link>

          {token ? (
            <>
              <div className="header-menu-open">
                <p
                  className="AfterLogheader__button"
                  onClick={toggleDropdown}
                >
                  {name}
                </p>
                {openDropDown && (
                  <div className="header-menu-options" ref={dropdownRef}>
                    <ul className="header-dropdown-menu">
                      <li onClick={goToProfile}>My Profile</li>
                      <li onClick={goToMessages}>Chat</li>
                      {/* <li onClick={() => navigate("/notifications")}>Notifications</li> */}
                      <li onClick={goToBlockList}>Block List</li>
                      <li className="account-privacy-dropdown">
                        <div onClick={toggleAccountPrivacy} className="account-privacy-trigger">
                          Account & Privacy
                          <span className="dropdown-arrow">{showAccountPrivacy ? '▼' : '▶'}</span>
                        </div>
                        {showAccountPrivacy && ( 
                          <ul className="account-privacy-submenu">
                            <li onClick={goToChangePassword}>Change Password</li>
                            <li onClick={goToDeleteProfile}>Delete Profile</li>
                          </ul>
                        )}
                      </li>
                      <li style={{color:"red", fontWeight: "500"}} onClick={handleShow1}>Logout</li>
                    </ul>
                  </div>
                )}
              </div>
            </>
          ) : (
            <>
              {vendor ? (
                <p className="header__button" onClick={() => naviGATE("/vendor-sign-in")}>
                  Login
                </p>
              ) : (
                <p className="header__button" onClick={() => naviGATE("/login")}>
                  Login
                </p>
              )}
            </>
          )}
        </div>
        <div className="side_navbar">
          <button onClick={handleShow}>
            <img src="/side-nav.png" alt="" className="img_for_side_nav" />
          </button>

          <Offcanvas show={show} backdropClassName="hyyyyyyy" onHide={handleClose}>
            <Offcanvas.Header closeButton>
              <Offcanvas.Title>
                <div>
                  <img src="/SaptaVidhi T.png" onClick={handleNav} alt="" style={{ width: "100px", cursor: "pointer" }} />
                </div>
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="side_nav_body">
              <div>
                <ul className="list-unstyled side_nav_link">
                  <li>
                    <Link
                      style={{ textDecoration: "none", color: "black" }}
                      to={token ? "/profile" : "/"}
                      onClick={handleClose}
                    >
                      Home
                    </Link>
                  </li>
                  {token && (
                    <li>
                      <Link
                        to="#"
                        style={{ textDecoration: "none", color: "black" }}
                        onClick={async (e) => {
                          e.preventDefault();
                          if (await checkPersonalDetails()) {
                            navigate("/userprofile");
                            handleClose();
                          }
                        }}
                      >
                        My Profile
                      </Link>
                    </li>
                  )}
                  {token && (
                    <li>
                      <Link
                        to="#"
                        style={{ textDecoration: "none", color: "black" }}
                        onClick={async (e) => {
                          e.preventDefault();
                          if (await checkPersonalDetails()) {
                            navigate("/messages");
                            handleClose();
                          }
                        }}
                      >
                        Chat
                      </Link>
                    </li>
                  )}
                  {token && (
                    <li>
                      <Link
                        to="/blocklist"
                        style={{ textDecoration: "none", color: "black" }}
                        onClick={handleClose}
                      >
                        Block List
                      </Link>
                    </li>
                  )}
                  {token && (
                    <li>
                      <Link
                        style={{ textDecoration: "none", color: "black" }}
                        to="/requests"
                        onClick={handleClose}
                      >
                        Requests
                      </Link>
                    </li>
                  )}
                  <li>
                    <Link
                      style={{ textDecoration: "none", color: "black" }}
                      to="/SelectPlan"
                      onClick={handleClose}
                    >
                      Our Plans
                    </Link>
                  </li>
                  <li>
                    <Link
                      style={{ textDecoration: "none", color: "black" }}
                      to="/ContactUs"
                      onClick={handleClose}
                    >
                      Contact Us
                    </Link>
                  </li>
                  {token && (
                    <li>
                      <div className="sidebar-account-privacy">
                        <div onClick={toggleAccountPrivacy} className="sidebar-privacy-trigger">
                          Account & Privacy
                          <span className="dropdown-arrow">{showAccountPrivacy ? '▼' : '▶'}</span>
                        </div>
                        {showAccountPrivacy && (
                          <ul className="sidebar-privacy-submenu">
                            <li>
                              <Link
                                style={{ textDecoration: "none", color: "black" }}
                                to="/change-password"
                                onClick={handleClose}
                              >
                                Change Password
                              </Link>
                            </li>
                            <li>
                              <Link
                                style={{ textDecoration: "none", color: "black" }}
                                to="#"
                                onClick={handleClose}
                              >
                                Delete Profile
                              </Link>
                            </li>
                          </ul>
                        )}
                      </div>
                    </li>
                  )}
                  {/* {token && (
                    <li>
                      <Link
                        to="#"
                        style={{ textDecoration: "none", color: "black" }}
                        onClick={async (e) => {
                          e.preventDefault();
                          if (await checkPersonalDetails()) {
                            navigate("/notifications");
                            handleClose();
                          }
                        }}
                      >
                        Notifications
                      </Link>
                    </li>
                  )} */}
                </ul>
                {token ? (
                  <div className="Logout_btn_nav">
                    <button
                      onClick={() => {
                        handleLogout();
                      }}
                    >
                      Log Out
                    </button>
                  </div>
                ) : (
                  <div className="Logout_btn_nav">
                    <button
                      onClick={handleLogin}
                    >
                      Login
                    </button>
                  </div>
                )}
              </div>
            </Offcanvas.Body>
          </Offcanvas>
        </div>
      </div>
    </div>
  );
};

export default Header;
